import {rebindOnMethod} from '../../modules/util';

export default function(listeners) {
  return rebindOnMethod(this, listeners);
}


// WEBPACK FOOTER //
// ./layouts/default/rebindOnMethod.js